module.exports = __webpack_public_path__ + "static/img/logo-black.803aea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/logo-black.png
// module id = pR34
// module chunks = 1